import type { Types as OData } from 'shared/odata'

import { ConfirmationDialogRunning } from 'components/atoms/ConfirmationDialogRunning'

import type { Campaign } from '../types'

import { api } from '../api'
import { isInitState } from '../utils'
import { useAddContacts } from './actions'

export function useValidateAddContacts({
	onSuccess
}: { onSuccess?: () => void } = {}) {
	const [loadTarget, targetProps] = api.useAudienceValidateMutation()
	const [addContacts, addContactsProps] = useAddContacts()

	async function send(
		filters: Partial<OData.AudienceParams>,
		campaign: Campaign
	) {
		const { $filter, $orderby, $searchQuery } = filters

		const body = {
			$filter,
			$orderby,
			$searchQuery,
			id: campaign.id
		}

		async function requestAdd() {
			await addContacts(body)
			onSuccess?.()
		}

		const isDraft = isInitState(campaign!.state)

		if (isDraft) {
			return requestAdd()
		}

		const { data: validation } = await loadTarget(body)

		if (!validation) {
			return
		}

		const isValid =
			validation.valid_audience_count > 0 &&
			validation.validation_rules_summary.length === 0

		if (isValid) {
			return requestAdd()
		}

		ConfirmationDialogRunning.open({
			body,
			validation
		})
	}

	return [send, targetProps.isLoading || addContactsProps.isLoading] as const
}
